export const GIVEAWAY_FORM_DRAFT_KEY = 'brief-live-giveaway-form-draft';

export const InitialGiveawayItem = {
  productName: '',
  totalStock: null,
  imagePath: '',
  rules: {
    note: '',
    minimumPurchaseAmount: null,
    withProductPurchase: false,
    type: '',
    requiredProducts: [
      {
        sku: '',
        productName: '',
        imagePath: '',
      },
    ],
  },
  sessions: [
    {
      promotionDate: '',
      startTime: null,
      endTime: null,
      allocatedStock: null,
      accountLivestreamId: null,
    },
  ],
};

export const InitialValuesCreate = {
  brandId: null,
  title: '',
  giveaways: [InitialGiveawayItem],
};
